import Keycloak from 'keycloak-js'
const _kc = new Keycloak('/keycloak.json');
export default _kc